<template>
    <widget :title="title" :router="router">
        <selectCom :tabList="tabList" @getTab="getTab" type="subject" v-if="tabList.length > 0"></selectCom>
        <div class="widget_cont" ref="chart_ele" v-if="pieObj" :key="re"></div>
        <div class="null" v-if="!pieObj"><img src="../img/zj_widget/null.png"></div>
    </widget>
</template>
<script>
    import widget from './zj_warp'
    import selectCom from './select'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget,
            selectCom
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number,
                default:1
            },
            item:{
                type:Object
            }
        },
        filters:{
            format:function(val){
                return '.'+val.split('.')[1]
            }
        },
        data(){
            return {
                widgetType:1,
                router:'results_score_count_list',
                pieDate:{
                    passCount:0,
                    repeatCount:0,
                    makeupCount:0
                },
                configList:null,
                tabList:[],
                courseId:'',
                teacherId:window.appframe.$store.state.userInfo.id,
                widgetUrl:'/gateway/edumanage/widget/courseList',
                pieObj:null,
                re:1
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    vm.widgetUrl = stemp[0].apiUrl
                    vm.querySubject()
                }
            })
        },
        methods: {
            querySubject(){
                let vm = this
                http.get('/gateway/edumanage/widget/courseList?teacherId='+vm.teacherId).then(function(xhr){
                    vm.tabList = xhr.data.data
                    vm.courseId = vm.tabList[0].id
                    vm.query()
                })
            },
            query(){
                let vm = this
                http.get('/gateway/results/score/studentScoreSummary?teacherId='+vm.teacherId+'&courseId='+vm.courseId).then(function(xhr){
                    let objectA = xhr.data.data
                    vm.pieObj = objectA
                    if(objectA){
                        let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                        var newObj = new Object();
                        vm.pieDate = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                        vm.$nextTick(function(){
                            vm.myChart = echarts.init(vm.$refs["chart_ele"])
                            var option = {
                                color: ['#4CB7FE', '#FFC271', '#60E6CA'],
                                tooltip: {
                                    trigger: 'item'
                                },
                                legend: {
                                    orient: 'horizontal',
                                    top: 16,
                                    selectedMode: false,
                                    itemWidth: 12,
                                    itemHeight: 10,
                                    itemGap: 50,
                                    data: ['合格', '补考', '重修']
                                },
                                series: [{
                                    type: 'pie',
                                    radius: ['50%', '70%'],
                                    center:['50%','60%'],
                                    label:{
                                        show:false
                                    },
                                    data: [
                                        {name:'合格',value:vm.pieDate.passCount},
                                        {name:'补考',value:vm.pieDate.makeupCount},
                                        {name:'重修',value:vm.pieDate.repeatCount}
                                    ]
                                }]
                            };
                            vm.myChart.setOption(option);
                        })
                    }
                })
            },
            getTab(data){
                let vm = this
                vm.courseId = data.id
                vm.query()
            }
        }
    }
</script>
<style scoped lang="less">
    .widget_cont{
        height: 260px;
    }
    .null{
        text-align: center;
        line-height: 270px;
        img{
            vertical-align:middle;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/zj_student_achievement.vue